import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../AppContext";
import { ScreenContainer } from "../../components/containers";
import {
  KeyFeatureQuestions,
  POSSolutions,
  POSSolution,
} from "../../file.interface";

interface Question {
  label: KeyFeatureQuestions;
  answer: boolean;
}
const initialQuestions: Question[] = Object.values(KeyFeatureQuestions).map(
  (question) => ({
    label: question,
    answer: false,
  })
);

const FeaturesScreen2: React.FC = () => {
  const [questions, setQuestions] = useState<Question[]>(initialQuestions);
  const { dispatch } = useAppContext();
  const navigate = useNavigate();

  const handleQuestions = (qIndex: number, value: boolean) => {
    let _questions = [...questions];
    _questions[qIndex].answer = value;
    setQuestions(_questions);
  };

  const handleSelection = () => {
    let bronzeQuestions = POSSolutions[4].keyFeatureQuestions;
    let silverQuestions = POSSolutions[5].keyFeatureQuestions;
    let goldQuestions = POSSolutions[6].keyFeatureQuestions;
    let isBronze: boolean = false;
    let isSilver: boolean = false;
    let isGold: boolean = false;

    let positiveSelection = questions
      .filter((question) => question.answer)
      .map((positives) => positives.label);

    positiveSelection?.forEach((question) => {
      isBronze = bronzeQuestions?.includes(question) ?? false;
      isSilver = silverQuestions?.includes(question) ?? false;
      isGold = goldQuestions?.includes(question) ?? false;
    });

    if (!isBronze && isSilver && isGold) {
      //isSilver
      console.log("IS SILVER");
      updatePOSSolution(POSSolutions[5]);
    } else if (!isBronze && !isSilver && isGold) {
      console.log("IS GOLD");
      //isGold
      updatePOSSolution(POSSolutions[6]);
    } else {
      console.log("IS BRONZE");
      //isBronze
      updatePOSSolution(POSSolutions[4]);
    }

    navigate("/sites-screen-3");
  };

  const updatePOSSolution = (solution: POSSolution): void => {
    dispatch({
      type: "UPDATE_CONTEXT",
      payload: { selectedPOSSolution: solution },
    });
  };
  return (
    <ScreenContainer
      title="Key Features"
      subtitle="Choose as many features as you think you need."
    >
      {questions.length && (
        <div className="questions-container">
          {questions.map((question, index) => (
            <div className="yes-no-container" key={index}>
              <span>
                {index + 1}. {question.label}
              </span>
              <div className="answers-container">
                <div
                  className={`${question.answer && "yes-selected"} option`}
                  onClick={() => handleQuestions(index, true)}
                >
                  Yes
                </div>
                <div
                  className={`${!question.answer && "no-selected"} option`}
                  onClick={() => handleQuestions(index, false)}
                >
                  No
                </div>
              </div>
              {index < questions.length - 1 && <div style={{ height: 30 }} />}
            </div>
          ))}
        </div>
      )}

      <div className="buttons-container">
        <button
          className="app-button previous-button"
          onClick={() => navigate(-1)}
        >
          Previous
        </button>
        {questions.some((e) => e.answer) && (
          <button
            className="app-button next-button"
            onClick={() => handleSelection()}
          >
            Next
          </button>
        )}
      </div>
    </ScreenContainer>
  );
};

export default FeaturesScreen2;
